import {
  type BaseQueryFn,
  type FetchArgs,
  type FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

import { getToken } from '../../auth';

/**
 * Gets the base API URL based on proxy configuration
 * - Proxy enabled (VITE_USE_PROXY=true): Use /api (Vite will proxy to backend)
 * - Proxy disabled: Use direct backend URL from VITE_BASE_API_URL
 */
const getBaseApiUrl = (): string => {
  const useProxy = import.meta.env.VITE_USE_PROXY === 'true';
  if (useProxy) {
    // When using proxy, use /api prefix which Vite will proxy to backend
    return '/api';
  }
  // When not using proxy, use direct backend URL
  return import.meta.env.VITE_BASE_API_URL || '';
};

const BASE_API_URL = getBaseApiUrl();
type BaseApiOptions = {
  version?: string;
  overrideBaseUrl?: string;
};

export const createBaseQuery = ({
  version = 'v1',
  overrideBaseUrl = BASE_API_URL,
}: BaseApiOptions): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =>
  fetchBaseQuery({
    baseUrl: `${overrideBaseUrl}/${version}`,
    prepareHeaders: async (headers) => {
      const token = await getToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  });
